import type { IController, IAugmentedJQuery } from 'angular';
import type { AuthenticationService } from '../Auth/mx-authentication-service';
import type { ColorService } from './color.service';

class MxUnauthThemeCtrl implements IController {
	public static readonly $inject = ['$element', 'mx.shell.AuthService', 'mx.app.ColorService'];

	constructor(
		readonly $element: IAugmentedJQuery,
		readonly authService: AuthenticationService,
		readonly colorService: ColorService
	) {}

	public async $postLink() {
		const uiCfg = (await this.authService.getLoginParams()).LoginUiConfig || {};

		const setStyle = (selector: string, propery: string, value: string | undefined) => {
			if (typeof value !== 'undefined') {
				this.$element.find(selector).css(propery, value);
			}
		};

		this.$element.find('.mx-unauth-page--logo').attr('src', uiCfg.Logo);
		setStyle('.mx-unauth-page--bg-image', 'backgroundColor', uiCfg.BackgroundColor);
		setStyle('.mx-unauth-page--bg-image', 'backgroundImage', `url(${uiCfg.BackgroundImage})`);
		setStyle('.mx-unauth-page--bg-overlay', 'backgroundColor', `#00000080`);
		setStyle('.mx-unauth-form', 'backgroundImage', `url(${uiCfg.LeftForegroundImage})`);

		if (uiCfg.BlurBackgroundImage) {
			setStyle('.mx-unauth-page--bg-overlay', 'backdropFilter', 'blur(10px)');
		}

		let stylesEl = $('#mx-unauth-page--styles');
		if (!stylesEl.length) {
			stylesEl = $('<style id="mx-unauth-page--styles"></style>');
			$('body').append(stylesEl);
		}

		const minContrastForErrorText = 4.5;
		const isDarkModeForLinks = this.colorService.getLuminanace(uiCfg.ButtonColor) >= this.colorService.getLuminanace(uiCfg.LeftForegroundColor);
		const currentContrastRatioForLinks = this.colorService.getContrastRatio(uiCfg.ButtonColor, uiCfg.LeftForegroundColor);
		const minContrastForDarkMode = 4.5;
		const minContrastForLightMode = 3;
		const contrastEdgeToStartAutotuneForLightMode = 2.2; // it's lower than minContrastForLightMode because often Designers want to have not so contrast links (e.g. Orange Links on White BG)
		const minContrastForLightModeForLinks = !isDarkModeForLinks && currentContrastRatioForLinks < contrastEdgeToStartAutotuneForLightMode ? minContrastForLightMode : 0;
		const minContrastRatioForLinks = isDarkModeForLinks ? minContrastForDarkMode : minContrastForLightModeForLinks;

		stylesEl.text(`
			.mx-unauth-page {
				--mx-content-text-color: ${uiCfg.TextColor};
				--mx-content-bg-color: ${uiCfg.LeftForegroundColor};
				--mx-faded-color: color-mix(in srgb, var(--mx-content-text-color) 67%, transparent);
				--mx-disabled-text-color: color-mix(in srgb, var(--mx-content-text-color) 50%, transparent);
				--mx-action-btn-color: ${uiCfg.ButtonColor};
				--mx-action-btn-color-hover: color-mix(in srgb, ${uiCfg.ButtonColor} 88%, black);
				--mx-action-btn-text-color: ${uiCfg.ButtonTextColor};
				--mx-active-color: ${this.colorService.enhanceColorContrast(uiCfg.ButtonColor, uiCfg.LeftForegroundColor, minContrastRatioForLinks)};
				--mx-active-text-color: var(--mx-active-color);
				--mx-error-text-color: ${this.colorService.enhanceColorContrast('#FF0000', uiCfg.LeftForegroundColor, minContrastForErrorText)};

				--mx-input-border-color: color-mix(in srgb, var(--mx-active-color) 12%, color-mix(in srgb, var(--mx-content-text-color) 24%, var(--mx-content-bg-color)));
				--mx-input-border-color-hover: color-mix(in srgb, var(--mx-active-color) 50%, var(--mx-input-border-color));

				--mx-scrollbar-color-bg: color-mix(in srgb, var(--mx-content-text-color) 8%, var(--mx-content-bg-color));
				--mx-scrollbar-color: color-mix(in srgb, var(--mx-content-text-color) 43%, var(--mx-content-bg-color));
				scrollbar-color: var(--mx-scrollbar-color) var(--mx-scrollbar-color-bg);
			}
		`);

		// Potential fix for AutoPrefilled Input Fields with overlapped Labels (simple selection in DOM do the job)
		setTimeout(() => $('input'), 2000);
	}
}

export function MxUnauthThemeDirective() {
	return {
		restrict: 'A',
		controller: MxUnauthThemeCtrl,
	};
}
